module.exports = __webpack_public_path__ + "static/media/Integrations@2x.25f954e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Integrations@2x.png
// module id = 356
// module chunks = 1